import { render, staticRenderFns } from "./ClinicInvoicesData.vue?vue&type=template&id=b0e1fbd4"
import script from "./ClinicInvoicesData.vue?vue&type=script&lang=js"
export * from "./ClinicInvoicesData.vue?vue&type=script&lang=js"
import style0 from "./ClinicInvoicesData.vue?vue&type=style&index=0&id=b0e1fbd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports